import React from 'react';
import { useCallback } from 'react';
import { LexicalEditor } from 'lexical';
import { $patchStyleText } from '@lexical/selection';
import { $getSelection } from 'lexical';
import DropDown, { DropDownItem } from '../../../ui/DropDown';

export const FONT_FAMILY_OPTIONS: [string, string][] = [
  ['Arial', 'Arial'],
  ['Courier New', 'Courier New'],
  ['Georgia', 'Georgia'],
  ['Times New Roman', 'Times New Roman'],
  ['Trebuchet MS', 'Trebuchet MS'],
  ['Verdana', 'Verdana'],
  ['sans-serif', 'Sans Serif']
];

export const FONT_SIZE_OPTIONS: [string, string][] = [
  ['10px', '10px'],
  ['11px', '11px'],
  ['12px', '12px'],
  ['13px', '13px'],
  ['14px', '14px'],
  ['15px', '15px'],
  ['16px', '16px'],
  ['17px', '17px'],
  ['18px', '18px'],
  ['19px', '19px'],
  ['20px', '20px']
];

export function dropDownActiveClass(active: boolean) {
  if (active) return 'active dropdown-item-active';
  return '';
}

interface FontDropDownProps {
  editor: LexicalEditor;
  value: string;
  style: string;
  disabled?: boolean;
}

export function FontDropDown({
  editor,
  value,
  style,
  disabled = false
}: FontDropDownProps): JSX.Element {
  const handleClick = useCallback(
    (option: string) => {
      editor.update(() => {
        const selection = $getSelection();
        if (selection !== null) {
          $patchStyleText(selection, {
            [style]: option
          });
        }
      });
    },
    [editor, style]
  );
  let buttonLabel = value;
  if (style === 'font-family') {
    const match = FONT_FAMILY_OPTIONS.find(([optionValue]) => optionValue === value);
    buttonLabel = match ? match[1] : value;
  }
  const buttonAriaLabel =
    style === 'font-family'
      ? 'Formatting options for font family'
      : 'Formatting options for font size';

  return (
    <DropDown
      disabled={disabled}
      buttonClassName={'toolbar-item ' + style}
      buttonLabel={buttonLabel}
      buttonIconClassName={style === 'font-family' ? 'icon block-type font-family' : ''}
      buttonAriaLabel={buttonAriaLabel}
    >
      {(style === 'font-family' ? FONT_FAMILY_OPTIONS : FONT_SIZE_OPTIONS).map(([option, text]) => (
        <DropDownItem
          className={`item ${dropDownActiveClass(value === option)} ${
            style === 'font-size' ? 'fontsize-item' : ''
          }`}
          onClick={() => handleClick(option)}
          key={option}
        >
          <span className="text">{text}</span>
        </DropDownItem>
      ))}
    </DropDown>
  );
}
